import React from 'react'
import StyledScreen from './StyledScreen'

const StyledPage = StyledScreen.extend`
  background-color: white;
  color: black;
`

export default function Page(props) {
  return (
    <StyledPage>
      {props.children}
    </StyledPage>
  )
}



// WEBPACK FOOTER //
// ./src/components/Page.js